import { render, staticRenderFns } from "./HolidaysChildren.vue?vue&type=template&id=71297422&"
import script from "./HolidaysChildren.vue?vue&type=script&lang=js&"
export * from "./HolidaysChildren.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysChildren.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports